(() => {
  function init(root = document) {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const slides = [...gallery.querySelectorAll('[data-slide]')];
      const buttons = [...gallery.querySelectorAll('[data-gallery-index]')];
      const count = gallery.querySelector('[data-gallery-count]');
      let active = 0;
      function show(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== active; });
        buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === active)));
        if (count) count.textContent = `${active + 1} / ${slides.length}`;
      }
      buttons.forEach((button, index) => button.addEventListener('click', () => show(index)));
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(active - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(active + 1));
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          show(active + (event.key === 'ArrowRight' ? 1 : -1));
          buttons[active]?.focus();
        }
      });
      let startX = 0;
      const stage = gallery.querySelector('.lm-gallery-stage');
      stage.addEventListener('touchstart', e => { startX = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', e => {
        const distance = e.changedTouches[0].clientX - startX;
        if (Math.abs(distance) > 60) show(active + (distance < 0 ? 1 : -1));
      }, { passive: true });
      show(0);
    });
    root.querySelectorAll('.lm-mobile-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  let ticking = false;
  function updateSticky() {
    const product = document.querySelector('#the-set');
    const sticky = document.querySelector('.lm-sticky-duo');
    if (product && sticky) sticky.classList.toggle('is-visible', product.getBoundingClientRect().bottom < 100);
    ticking = false;
  }
  window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(updateSticky); ticking = true; } }, { passive: true });
  updateSticky();
})();
